module.exports = __webpack_public_path__ + "static/img/1.debdf49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/1.png
// module id = j5lQ
// module chunks = 0